import { makeStyles } from "@material-ui/core";

export const DoorReleaseListStyle = makeStyles((theme) => ({
    imageHolder: {
        margin: "1rem 0 0 1rem"
    },
}));